<template>
  <div class="news_item">
    <span class="news_date" v-if="news_item.Date">{{news_item.Date}}:</span>
    <span class="news_date" v-if="!news_item.Date">&nbsp;</span>
    <div class="news_text">
      <div class="news_block" v-if="news_item.News" v-html="convert_markdown(news_item.News)"></div>
      <a class="source_link" v-if="news_item['Source Url']" :href="news_item['Source Url']">Source</a>
    </div>
  </div>
</template>

<script>
import { Remarkable } from "remarkable";
var md = new Remarkable();

export default {
  props: ["news_item"],
  data() {
    return { updated_date: null };
  },
  methods: {
    convert_markdown(string) {
      return md.render(string);
    }
  }
};
</script>

<style >
.news_text > div {
  -webkit-column-width: 260px;
  -moz-column-width: 260px;
  column-width: 260px;
  max-width: 500px;
}

.news_date {
  font-weight: bold;
}
.news_item {
  padding-bottom: 1rem;
  background-color: white;
}
.news_block p {
  margin-bottom: 0.5rem;
}
</style>